import React, {Component} from 'react';
import {connect} from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import ActionTypes from "../../misc/actionTypes";
import Analytics from './../../analytics';
import UserLoginButton from './../ui/userLoginButton';
import {toggleUserPopup} from "../../actions/actionFunctions";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {saveQuote} from "../../api/server-api";
import {QuoteRequestType, UserPopupTypes} from "../visComponents/constants";
import {showQuoteSavedNotification} from "../ui/successNotification";

export class QuoteButton extends Component {

  handleSaveQuote = () => {
    const fabricatorSettings = this.props.fabricatorData.settings;
    const getQuoteEnabled = fabricatorSettings.enableQuote;
    if (!UserLoginButton.handleLoginClick({
      ...this.props,
      saveQuoteAfterLogin: true,
      userPopupType: UserPopupTypes.GetQuote
    })) {
      Analytics.sendClickEvent(getQuoteEnabled ? "get-quote-button-show-login" : "quote-button-show-login");
    } else {
      Analytics.sendClickEvent(getQuoteEnabled ? "get-quote-button" : "quote-button");
      this.saveQuoteSubmit();
    }
  };

  saveQuoteSubmit = () => {
    loaderEnable("loader.savingQuoteText");
    $(document).trigger(ActionTypes.REMOVE_GREEN_ZONE_ON_CANVAS, () => {
      saveQuote({submit: true, yesNoConsultationRequest: false, quoteRequestType: QuoteRequestType.RequestQuote})
        .then((response) => {
          if (response) {
            let responseDataBase = response;
            if (response.data) {
              responseDataBase = response.data;
            }
            const responseData = typeof responseDataBase === 'object' ? responseDataBase : JSON.parse(responseDataBase);
            console.log('saveQuote response:', responseData);
            loaderDisable();
          }
          showQuoteSavedNotification("successNotification.titleQuoteRequested");
          // downloadCanvasImageById(this.props.canvasId);
        }).catch((error) => {
        console.log('saveQuote error:', error);
        loaderDisable();
      })
    });
  };

  render() {
    return (
      <button className="mobilebutton mobilebutton--getquote"
              onClick={this.handleSaveQuote}>
        <span className="mobilebutton-text mobilebutton-text--getquote"><FormattedMessage id="getQuoteButton"/></span>
      </button>
    )
  }

}
const mapStateToProps = (store) => ({
  userIsLoggedIn: store.userState.userIsLoggedIn,
  isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  fabricatorData: store.fabricatorState
});
export default connect(mapStateToProps, {
  toggleUserPopup,
})(QuoteButton);
